var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.798 19.91a5.826 5.826 0 0010.389 2.953l6.584-8.458a5.826 5.826 0 00-5.41-9.347 5.824 5.824 0 00-3.784 2.192L20.217 9a1.395 1.395 0 002.202 1.711l1.36-1.749a3.035 3.035 0 114.791 3.73l-6.584 8.458a3.037 3.037 0 01-4.792-3.731l.304-.391a1.394 1.394 0 10-2.2-1.713l-.305.39a5.825 5.825 0 00-1.195 4.205zm8.278-4.484a5.89 5.89 0 00-10.492-2.89l-6.342 8.146a5.903 5.903 0 00-1.197 4.352c.4 3.212 3.33 5.515 6.553 5.114a5.87 5.87 0 003.944-2.268l1.04-1.366a1.395 1.395 0 00-2.218-1.69l-1.04 1.365a3.081 3.081 0 01-2.07 1.19 3.093 3.093 0 01-3.441-2.69 3.114 3.114 0 01.63-2.294l6.342-8.146a3.101 3.101 0 014.893 3.81l-.236.304a1.395 1.395 0 002.2 1.713l.237-.304a5.89 5.89 0 001.197-4.346z",
    fill: "current"
  })));
}

export default SvgLink;